<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  本人是否與其他公司簽訂競業禁止條款？
                  <p class="en-text">
                    Have I signed a non-competition clause with other companies?
                  </p>
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input type="radio" :value="true" v-model="HasNCC" />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input type="radio" :value="false" v-model="HasNCC" />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6"></div>

        <template v-for="(item, index) in nonCompete">
          <div class="col-md-6" :key="'Company' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    所負義務對象（與您約定競業禁止的公司）
                    <span class="en-text">Company's name</span>
                  </span>
                </div>
                <div class="field-value">
                  <input
                    type="text"
                    maxlength="200"
                    autocomplete="off"
                    readonly
                    @focus="$common.removeReadonly($event)"
                    v-model="item.Company"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'District' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    競業禁止區域
                    <span class="en-text">Non competition restrictions</span>
                  </span>
                </div>
                <div class="field-value">
                  <input
                    type="text"
                    placeholder="『例如：台北市、新北市、新竹市』"
                    maxlength="50"
                    autocomplete="off"
                    readonly
                    @focus="$common.removeReadonly($event)"
                    v-model="item.District"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'StartDate' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    競業禁止期間（起）
                    <span class="en-text">
                      Time for non-competition (Start)
                    </span>
                  </span>
                </div>
                <div class="field-value">
                  <el-date-picker
                    class="w-100"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="YYYY-MM-DD"
                    v-model="item.StartDate"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'EndDate' + index">
            <div class="field">
              <ValidationProvider
                :rules="{
                  required: true,
                  notBeforeStartDate: item.StartDate,
                }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    競業禁止期間（迄）
                    <span class="en-text">Time for non-competition (End)</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-date-picker
                    class="w-100"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="YYYY-MM-DD"
                    v-model="item.EndDate"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'Scope' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    競業禁止範圍
                    <span class="en-text">Non competition restrictions</span>
                  </span>
                </div>
                <div class="field-value">
                  <input
                    type="text"
                    placeholder="『例如：半導體設計業』"
                    maxlength="200"
                    autocomplete="off"
                    readonly
                    @focus="$common.removeReadonly($event)"
                    v-model="item.Scope"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'Remark' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  其他備註說明事項
                  <span class="en-text">Remark</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  placeholder="『請補充說明競業禁止條款其他有關事項（如有）』"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="item.Remark"
                />
              </div>
            </div>
          </div>

          <div class="col-md-12" :key="'ContractDesc' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  如無法提供，請說明原因
                </span>
              </div>
              <div class="field-value">
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="item.ContractDesc"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'ContractFileGroupGuid' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }"> 請上傳競業禁止合約 </span>
              </div>
              <div class="field-value">
                <el-upload
                  class="upload-demo w-100"
                  action
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="uploadFile"
                  v-model="item.ContractFileGroupGuid"
                >
                  <el-button
                    size="small"
                    type="primary"
                    style="margin-top: 5px"
                    @click="dataIndex = index"
                  >
                    點擊上傳
                  </el-button>
                </el-upload>
              </div>
            </div>

            <div
              v-for="(file, fileIndex) in item.ContractFiles"
              :key="file.FileGuid"
            >
              <p style="margin-top: -10px">
                <eva-icon fill="#5b5b5b" name="attach-outline" />
                <span
                  style="
                    margin-left: 15px;
                    vertical-align: text-top;
                    cursor: default;
                    color: #5b5b5b;
                  "
                >
                  {{ file.FileName }}
                </span>
                <span
                  style="display: inline-block; position: absolute; right: 15px"
                  @click.stop="
                    removeFile(
                      {
                        fileGuid: file.FileGuid,
                        fileIndex: fileIndex,
                      },
                      (dataIndex = index)
                    )
                  "
                >
                  <eva-icon fill="#5b5b5b" name="trash-2-outline" />
                </span>
              </p>
            </div>
          </div>

          <div
            v-if="nonCompete.length > 1"
            class="col-md-6"
            :key="'button' + index"
          >
            <button type="button" class="del-btn" @click="del(index)">
              {{ $t("BUTTON.RESUME_DELETE") }}
            </button>
          </div>
        </template>
      </div>

      <div class="edit-btn-wrap">
        <!-- 新增 -->
        <button v-if="HasNCC" type="button" class="btn-sm add-btn" @click="add">
          {{ $t("BUTTON.RESUME_ADD") }}
        </button>
        <!-- 儲存 -->
        <button type="button" class="put-btn" @click="handleSubmit(saveNCC)">
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLNonCompete",

  data() {
    return {
      HasNCC: null,
      nonCompete: [],

      dataIndex: "",

      fileGroupGuid: "",

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 上傳 檔案
    uploadFile(file) {
      let fileGroupGuid =
        this.nonCompete[this.dataIndex].ContractFileGroupGuid === null
          ? ""
          : this.nonCompete[this.dataIndex].ContractFileGroupGuid;
      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.nonCompete[this.dataIndex].ContractFileGroupGuid = response.data;
          this.getFileList(response.data);
        }
      });
    },

    // 取得 檔案清單
    getFileList(fileGroupGuid) {
      const params = {
        resetFileStatus: null,
      };
      this.$api.file.getFileDetails(params, fileGroupGuid).then((response) => {
        if (response.status === 200) {
          this.nonCompete[this.dataIndex].ContractFiles = response.data;
        }
      });
    },

    // 刪除檔案
    removeFile({ fileGuid, fileIndex }) {
      this.$api.file.removeFile(fileGuid).then((response) => {
        if (response.status === 200) {
          this.nonCompete[this.dataIndex].ContractFiles.splice(fileIndex, 1);
        }
      });
    },

    // 儲存 競業禁止
    saveNCC() {
      this.$api.idl
        .putNCC(this.source, {
          Details: this.nonCompete,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "競業禁止儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getNCC();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 競業禁止
    getNCC() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl.getNCC(this.source, candidate).then((response) => {
        if (response.status === 200) {
          this.HasNCC = response.data.HasNCC;
          this.nonCompete = response.data.Details;
        }
        this.updateLoading(false);
      });
    },

    add() {
      this.nonCompete.push({
        ContractFileGroupGuid: null,
        ContractFiles: [],
      });
    },

    del(index) {
      this.nonCompete.splice(index, 1);
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    HasNCC: function (newVal) {
      if (newVal) {
        if (this.nonCompete.length === 0) {
          this.add();
        }
      } else {
        this.nonCompete = [];
      }
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getNCC();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}

button {
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 15px;
}

.del-btn {
  background: #ff3232;
  margin-top: 20px;
  color: #fff;
  margin-right: 10px;
}

.edit-btn-wrap {
  margin-top: 20px;
  button {
    background: #18c58b;
    color: #fff;
  }
  .add-btn {
    background: #fff;
    color: #000;
    margin-right: 5px;
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
